import { render } from "./UserDialog.vue?vue&type=template&id=2b8a9da2&scoped=true"
import script from "./UserDialog.vue?vue&type=script&lang=js"
export * from "./UserDialog.vue?vue&type=script&lang=js"

import "./UserDialog.vue?vue&type=style&index=0&id=2b8a9da2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8a9da2"]])

export default __exports__